import { Form, message, Button, Input, Select, Row, Space, Modal } from "antd";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

export default function UserDetail() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [initialValues, setInitialValues] = useState({});
  const params = useParams();
  const userId = params?.id;

  const fetchUser = async () => {
    // Backend không có API getById cho user, chỉ có getAll
    // Nên với edit mode, ta sẽ không pre-fill form, admin sẽ nhập lại
    // Hoặc ta có thể fetch từ getAll rồi filter
    if (userId && userId !== "create") {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/admin/getAll`);
        const users = res?.data?.data || [];
        const user = users.find(u => u.id === parseInt(userId));
        if (user) {
          setInitialValues({
            username: user.username,
            email: user.email,
            fullname: user.fullname,
            role: user.role,
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const createUser = async (values) => {
    await axios.post(
      `${process.env.REACT_APP_API_URL}/admin/createUser`,
      {
        ...values,
        created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      }
    );
  };

  const updateUser = async (id, values) => {
    await axios.post(
      `${process.env.REACT_APP_API_URL}/admin/updateUser/${id}`,
      {
        ...values,
        create_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      }
    );
  };

  const deleteUser = async () => {
    await axios
      .delete(`${process.env.REACT_APP_API_URL}/admin/deleteUser/${userId}`)
      .then(() => {
        message.success("Xoá người dùng thành công");
        navigate("/admin/user");
      });
  };

  const confirmDelete = () => {
    Modal.confirm({
      icon: <ExclamationCircleOutlined />,
      content: "Bạn có chắc chắn xoá người dùng này?",
      okText: "Xác nhận",
      cancelText: "Huỷ",
      onOk: () => deleteUser(),
    });
  };

  useEffect(() => {
    if (userId && userId !== "create") {
      fetchUser();
    }
  }, [userId]);

  useEffect(() => {
    if (Object.keys(initialValues)?.length > 0) {
      form.resetFields();
    }
  }, [form, initialValues]);

  const onSubmit = async (values) => {
    try {
      if (userId && userId !== "create") {
        await updateUser(userId, values);
        message.success("Cập nhật thành công");
      } else {
        await createUser(values);
        message.success("Tạo người dùng thành công");
      }
      navigate("/admin/user");
    } catch (error) {
      console.error(error);
      message.error("Có lỗi xảy ra. Vui lòng kiểm tra lại thông tin.");
    }
  };

  return (
    <div className={"p-[40px] bg-white rounded-[10px]"}>
      <div className={"!text-[#2d2e32] pb-[10px]"}>
        <Link
          to={"/admin/user"}
          className={
            "text-[18px] sm:text-[24px] md:text-[26px] xl:text-[26px] font-[500] cursor-pointer"
          }
        >
          {userId && userId !== "create" ? "Cập nhật người dùng" : "Tạo người dùng"}
        </Link>
      </div>

      <Form
        layout={"vertical"}
        colon={false}
        form={form}
        initialValues={initialValues}
        onFinishFailed={(e) => console.log(e)}
        onFinish={onSubmit}
      >
        <Form.Item
          label={"Username"}
          name="username"
          rules={[{ required: true, message: "Vui lòng nhập username!" }]}
        >
          <Input size="large" placeholder={"Nhập username"} />
        </Form.Item>

        <Form.Item
          label={"Email"}
          name="email"
          rules={[
            { required: false },
            { type: "email", message: "Email không hợp lệ!" }
          ]}
        >
          <Input size="large" placeholder={"Nhập email (không bắt buộc)"} />
        </Form.Item>

        <Form.Item
          label={"Password"}
          name="password"
          rules={[
            { 
              required: userId === "create", 
              message: "Vui lòng nhập mật khẩu!" 
            },
            {
              min: 6,
              message: "Mật khẩu phải có ít nhất 6 ký tự!"
            }
          ]}
        >
          <Input.Password 
            size="large" 
            placeholder={userId && userId !== "create" ? "Để trống nếu không đổi mật khẩu" : "Nhập mật khẩu"} 
          />
        </Form.Item>

        <Form.Item
          label={"Họ tên"}
          name="fullname"
          rules={[{ required: false }]}
        >
          <Input size="large" placeholder={"Nhập họ tên (không bắt buộc)"} />
        </Form.Item>

        <Form.Item
          label={"Vai trò"}
          name="role"
          rules={[{ required: true, message: "Vui lòng chọn vai trò!" }]}
        >
          <Select
            size="large"
            placeholder="Chọn vai trò"
            options={[
              { value: 1, label: "User" },
              { value: 2, label: "Admin" },
            ]}
          />
        </Form.Item>

        <Row gutter={40} className={"my-[40px] pl-[20px]"}>
          <Space align="center">
            <Button type={"primary"} htmlType={"submit"}>
              {userId && userId !== "create" ? "Cập nhật" : "Tạo"}
            </Button>
            {userId && userId !== "create" && (
              <Button type={"primary"} danger onClick={confirmDelete}>
                Xoá
              </Button>
            )}
          </Space>
        </Row>
      </Form>
    </div>
  );
}
